import React from "react";
const ChevronRight = (props) => (React.createElement("svg", Object.assign({ width: "32px", height: "57px", viewBox: "0 0 32 57" }, props, { xmlns: "http://www.w3.org/2000/svg" }),
    React.createElement("path", { d: "M3.6 57.2c-.9 0-1.9-.4-2.6-1.1-1.4-1.4-1.4-3.7 0-5.2l22.3-22.3L1.1 6.3c-1.4-1.4-1.4-3.7 0-5.2 1.4-1.4 3.7-1.4 5.2 0l24.9 25c1.4 1.4 1.4 3.7 0 5.2L6.3 56c-.7.8-1.7 1.2-2.7 1.2z" })));
export default ChevronRight;
